
import API from "@irati/utils/services/API"
import endpoints from "@irati/utils/endpoints"


export const getSearchConfig = (params) => {
  if (params && typeof params !== "object") {
    throw new TypeError(
      `search expects "params" to be an object, instead got ${typeof params}`
    )
  }
  return {
    params
  }
}

export const search = (params) => {
  return API.get(`${endpoints.deals}`, {params}).then((deals) => {
    return {
      data: {
        q: deals.config.params.q,
        lat: deals.config.params.lat,
        lng: deals.config.params.lng,
        radius: deals.config.params.radius,
        boundingBox: deals.config.params.insideBoundingBox,
        results: {
          deals: deals.data.data,
          total: deals.data.total
        }
      }
    }
  })
}
